import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import PageHeader from "../../../components/PageHeader";
import { Helpers } from "../../../helpers/Helpers";
import { AddProductRequest } from "../../../models/request/product/AddProductRequest";
import { ProductService } from "../../../services/ProductService";
import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { AddProductResponse } from "../../../models/response/product/AddProductResponse";
import { GetProductByIdResponse, GetProductByIdResponseProductBarcode, GetProductByIdResponseProductSubProduct } from "../../../models/response/product/GetProductByIdResponse";
import GeneralInformation from "./Components/GeneralInformation";
import MeasureInformation from "./Components/MeasureInformation";
import BarcodeInformation from "./Components/BarcodeInformation";
import Barcodes from "./Components/Barcodes";
import SubProducts from "./Components/SubProducts";

const ProductAdd = () => {
    const navigate = useNavigate();
    const pageName = "Depo Modülü > Tanımlamalar > Ürün Tanımlama"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();

    const generalInformationRef: any = useRef();
    const measureInformationRef: any = useRef();
    const barcodeInformationRef: any = useRef();
    const productBarcodesRef: any = useRef();
    const productSubProductsRef: any = useRef();


    const [productId, setProductId] = useState<string | undefined>(undefined);
    const [selectedProductGroup, setSelectedProductGroup] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [name, setName] = useState<string | undefined>(undefined);
    const [description, setDescription] = useState<string | undefined>(undefined);
    const [selectedPotType, setSelectedPotType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [isSubProduct, setIsSubProduct] = useState(false);
    const [minStock, setMinStock] = useState<string | undefined>('0');
    const [isCustomActive, setIsCustomActive] = useState<boolean>(true);
    const fileRef: any = useRef();
    const [file, setFile] = useState<File | undefined>(undefined);
    const [b64, setB64] = useState(Helpers.getPlaceholder());

    const [width, setWidth] = useState<string | undefined>('0');
    const [length, setLength] = useState<string | undefined>('0');
    const [height, setHeight] = useState<string | undefined>('0');
    const [volume, setVolume] = useState<string | undefined>('0');
    const [desi, setDesi] = useState<string | undefined>('0');
    const [weight, setWeight] = useState<string | undefined>('0');

    const [isSerialNoRequired, setIsSerialNoRequired] = useState(false);
    const [isCompanyBarcodeRequired, setIsCompanyBarcodeRequired] = useState(false);
    const [isKeylogxBarcodeRequired, setIsKeylogxBarcodeRequired] = useState(false);

    const [productBarcodes, setProductBarcodes] = useState<GetProductByIdResponseProductBarcode[]>([]);
    const [productSubProducts, setProductSubProducts] = useState<GetProductByIdResponseProductSubProduct[]>([]);

    const [quantityInBox, setQuantityInBox] = useState<string | undefined>(undefined);
    const [quantityInPackage, setQuantityInPackage] = useState<string | undefined>(undefined);
    const [quantityInPallet, setQuantityInPallet] = useState<string | undefined>(undefined);

    const handleFileRead = async (event: any, setFunction: React.Dispatch<React.SetStateAction<string>>) => {
        try {
            const file = event.target.files[0]
            const base64: any = await convertBase64(file)
            setFunction(base64);
        } catch (error) {
            setFunction(Helpers.getPlaceholder())
        }
    }

    const convertBase64 = (file: any) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file)
            fileReader.onload = () => {
                resolve(fileReader.result);
            }
            fileReader.onerror = (error) => {
                reject(error);
            }
        })
    }

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetProductByIdResponse = await ProductService.getProductById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setProductId(response.data.productId);

                if (response.data.productGroupId)
                    setSelectedProductGroup({ label: response.data.productGroupName, value: response.data.productGroupId });

                setName(response.data.name);
                setDescription(response.data.description);

                if (response.data.potTypeId)
                    setSelectedPotType({ label: response.data.potTypeName, value: response.data.potTypeId, additionalValue1: response.data.potTypeKey });

                setIsSubProduct(response.data.isSubProduct);

                setMinStock(response.data.minStock?.toString());

                setIsCustomActive(response.data.isCustomActive);

                setWidth(response.data.width?.toString());
                setLength(response.data.length?.toString());
                setHeight(response.data.height?.toString());
                setVolume(response.data.volume?.toString());
                setDesi(response.data.desi?.toString());
                setWeight(response.data.weight?.toString());

                setIsSerialNoRequired(response.data.isSerialNoRequired);
                setIsCompanyBarcodeRequired(response.data.isCompanyBarcodeRequired);
                setIsKeylogxBarcodeRequired(response.data.isKeylogxBarcodeRequired);

                setProductBarcodes(response.data.productBarcodes);
                setProductSubProducts(response.data.productSubProducts);

                setB64(Helpers.isEmpty(response.data.image) ? Helpers.getPlaceholder() : response.data.image);

                setQuantityInBox(response.data.quantityInBox?.toString());
                setQuantityInPackage(response.data.quantityInPackage?.toString());
                setQuantityInPallet(response.data.quantityInPallet?.toString());
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const saveProduct = async () => {
        try {
            if (Helpers.isEmpty(selectedProductGroup))
                toast.error('Ürün Grubu alanı zorunludur!');
            else if (Helpers.isEmpty(name))
                toast.error('Ad alanı zorunludur!');
            else if (Helpers.isEmpty(selectedPotType))
                toast.error('Birimi alanı zorunludur!');
            else {
                dispatch(storeActivityIndicator(true));

                var obj: AddProductRequest = {
                    productId: productId,
                    productGroupId: selectedProductGroup?.value,
                    name: name,
                    description: description,
                    potTypeId: selectedPotType?.value,
                    isSubProduct: isSubProduct ? 1 : 0,
                    minStock: minStock,
                    isCustomActive: isCustomActive ? 1 : 0,
                    width: width,
                    length: length,
                    height: height,
                    volume: volume,
                    desi: desi,
                    weight: weight,
                    isSerialNoRequired: isSerialNoRequired ? 1 : 0,
                    isCompanyBarcodeRequired: isCompanyBarcodeRequired ? 1 : 0,
                    isKeylogxBarcodeRequired: isKeylogxBarcodeRequired ? 1 : 0,
                    image: file,
                    imageUrl: (b64.startsWith("http") ? b64 : undefined),
                    quantityInBox: quantityInBox,
                    quantityInPackage: quantityInPackage,
                    quantityInPallet: quantityInPallet,
                    productBarcodes: productBarcodes.map(function (x) {
                        return {
                            productBarcodeId: x.productBarcodeId.startsWith('newrecrd') ? undefined : x.productBarcodeId,
                            barcodeNo: x.barcodeNo,
                            barcodeTypeId: x.barcodeTypeId,
                            isCustomActive: x.isCustomActive ? 1 : 0,
                        }
                    }),
                    productSubProducts: productSubProducts.map(function (x) {
                        return {
                            productSubProductId: x.productSubProductId.startsWith('newrecrd') ? undefined : x.productSubProductId,
                            quantity: x.quantity?.toString(),
                            subProductId: x.subProductId
                        }
                    })
                }

                var response: AddProductResponse = await ProductService.addProduct(obj);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                toast.success(response.message)

                dispatch(storeActivityIndicator(false));
                navigate(Helpers.getGoBackUrl())
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <PageHeader
                        items={[
                            { text: 'Genel Bilgiler', ref: generalInformationRef },
                            { text: 'Ölçü Bilgileri', ref: measureInformationRef },
                            { text: 'Barkod Bilgileri', ref: barcodeInformationRef },
                            { text: 'Barkodlar', ref: productBarcodesRef },
                            !isSubProduct ? { text: 'Alt Ürünler', ref: productSubProductsRef } : undefined,
                        ]}
                    />

                    <GeneralInformation
                        generalInformationRef={generalInformationRef}
                        isCustomActive={isCustomActive}
                        isSubProduct={isSubProduct}
                        minStock={minStock}
                        name={name}
                        description={description}
                        selectedPotType={selectedPotType}
                        selectedProductGroup={selectedProductGroup}
                        setIsCustomActive={setIsCustomActive}
                        setIsSubProduct={setIsSubProduct}
                        setMinStock={setMinStock}
                        setName={setName}
                        setDescription={setDescription}
                        setSelectedPotType={setSelectedPotType}
                        setSelectedProductGroup={setSelectedProductGroup}
                        b64={b64}
                        fileRef={fileRef}
                        handleFileRead={handleFileRead}
                        setB64={setB64}
                        setFile={setFile}
                        quantityInBox={quantityInBox}
                        quantityInPackage={quantityInPackage}
                        quantityInPallet={quantityInPallet}
                        setQuantityInBox={setQuantityInBox}
                        setQuantityInPackage={setQuantityInPackage}
                        setQuantityInPallet={setQuantityInPallet}
                    />

                    <MeasureInformation
                        desi={desi}
                        height={height}
                        length={length}
                        measureInformationRef={measureInformationRef}
                        setDesi={setDesi}
                        setHeight={setHeight}
                        setLength={setLength}
                        setVolume={setVolume}
                        setWeight={setWeight}
                        setWidth={setWidth}
                        volume={volume}
                        weight={weight}
                        width={width}
                    />

                    <BarcodeInformation
                        barcodeInformationRef={barcodeInformationRef}
                        isCompanyBarcodeRequired={isCompanyBarcodeRequired}
                        isKeylogxBarcodeRequired={isKeylogxBarcodeRequired}
                        isSerialNoRequired={isSerialNoRequired}
                        setIsCompanyBarcodeRequired={setIsCompanyBarcodeRequired}
                        setIsKeylogxBarcodeRequired={setIsKeylogxBarcodeRequired}
                        setIsSerialNoRequired={setIsSerialNoRequired}
                    />

                    <Barcodes
                        productBarcodes={productBarcodes}
                        productBarcodesRef={productBarcodesRef}
                        setProductBarcodes={setProductBarcodes}
                    />

                    {
                        !isSubProduct && (
                            <SubProducts
                                productSubProducts={productSubProducts}
                                productSubProductsRef={productSubProductsRef}
                                setProductSubProducts={setProductSubProducts}
                            />
                        )
                    }

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveProduct}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default ProductAdd;